import { AuthenticatedApiRequest } from '@goldspotdiscoveries/auth';
import {
  FileDirectoryParams,
  FileDirectoryResponse,
} from '../../TypeScript/interfaces';
// https://github.com/GoldspotDiscoveries/gsp-tf-api-files/blob/main/OpenAPI/files-api.yaml

export const getFile = (filePath: string): Promise<any> => {
  const fileExt: string = filePath.split('.')[filePath.split('.').length - 1];
  return new Promise((resolve, reject) => {
    AuthenticatedApiRequest({
      method: 'get',
      apiName: 'Files',
      path: filePath,
    })
      .then((response: any) => {
        // new GET /files response
        if (
          response.result &&
          typeof response.result === 'string' &&
          /^https:\/\//.test(response.result)
        ) {
          const tempFileUrl: string = response.result;
          return useTempUrl(tempFileUrl, fileExt);
        }
        // old GET /files response
        else {
          return response;
        }
      })
      .then((response: any) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const useTempUrl = (tempFileUrl: string, fileExt: string) => {
  return new Promise((resolve, reject) => {
    fetch(tempFileUrl)
      .then((response: Response) => {
        if (fileExt === 'json') {
          return response.json();
        } else {
          return response.blob();
        }
      })
      .then((result: any) => {
        if (fileExt !== 'json') {
          resolve(result.text());
        } else {
          resolve(result);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getFileDirectory = (
  path: string,
  queryParams?: FileDirectoryParams,
): Promise<FileDirectoryResponse> => {
  return new Promise((resolve, reject) => {
    const params: string[] = Object.keys(queryParams || {}).map(
      (key: string): string => {
        const value: string = (queryParams || ({} as any))[key];
        return `${key}=${value}`;
      },
    );
    AuthenticatedApiRequest({
      method: 'get',
      apiName: 'Files',
      path: `${path}?${params.join('&')}`,
    })
      .then((result: any) => {
        const directoryResponse: FileDirectoryResponse = result;

        // any manipulation that is specific to this request
        resolve(directoryResponse);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const putFile = (
  file: any,
  filePath: string,
  fileType: string,
): Promise<any> => {
  return new Promise((resolve, reject) => {
    AuthenticatedApiRequest({
      method: 'put',
      apiName: 'Files',
      path: filePath,
      postData: {
        body: file,
        headers: {
          'Content-Type': fileType,
        },
      },
    })
      .then((result: any) => {
        if (result.result) {
          const headers: Headers = new Headers();
          headers.append('Content-Type', fileType);
          const requestInfo: any = {
            method: 'PUT',
            headers,
            body: JSON.stringify(file),
          };
          return fetch(result.result, requestInfo);
        } else {
          resolve(result);
        }
      })
      .then((result: any) => {
        resolve(result);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteFile = (path: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    AuthenticatedApiRequest<{ message?: string; error?: string }>({
      method: 'delete',
      apiName: 'Files',
      path,
    })
      .then((result) => {
        if (result.error) {
          reject(result);
        } else {
          resolve();
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};
